module.exports = __webpack_public_path__ + "img/locationDot_green.0c5ca687.svg";